<template>
  <div v-show="currentTrack" class="player-container">
    <p class="title"><b>{{ currentTitle }}</b></p>
    <div class="player">
      <vue-plyr :options="playerOptions">
        <audio controls ref="player">
          <source :src="currentTrack" type="audio/mp3" />
        </audio>
      </vue-plyr>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentTrack() {
      return this.$store.state.currentTrack;
    },
    currentTitle() {
      return this.$store.state.currentTitle;
    },
    currentRoute() {
      return this.$store.state.currentRoute;
    },
    playerOptions() {
      const options = {
        invertTime: false,
        controls: [
          'play-large', // The large play button in the center
          'restart', // Restart playback
          'play', // Play/pause playback
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'mute', // Toggle mute
          'volume', // Volume control
          'airplay', // Airplay (currently Safari only)
          'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
        ],
      };
      return options;
    },
  },
  watch: {
    currentTrack(newTrack) {
      if (newTrack) {
        this.$refs.player.load();
        this.$refs.player.play();
      }
    },
  },
  async mounted() {
    this.$watch('files', () => {
      this.$refs.player.load();
    });

    document.querySelectorAll('[data-plyr="download"]')[0].addEventListener('click', e => {
      e.preventDefault();
      window.open(this.currentTrack, '_blank');
      return null;
    });
  },
};
</script>

<style scoped>
.player-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #ccc;
  z-index: 1000;
}
.title {
  font-size: 0.8em;
  justify-content: center;
  margin: 10px 0 -5px;
  display: flex;
}
.player {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 0 5px;
}
</style>